import { gql } from "@apollo/client";

export const UPLOAD_RAG_DOCUMENT = gql`
  mutation UploadRagDocument(
    $file: Upload!
    $sourceType: String!
    $subject: ID
    $yearGroup: ID
    $educationLevel: ID
    $school: ID
    $parent: ID
    $containsMultipleInstances: Boolean
  ) {
    uploadRagDocument(
      file: $file
      sourceType: $sourceType
      subject: $subject
      yearGroup: $yearGroup
      educationLevel: $educationLevel
      school: $school
      parent: $parent
      containsMultipleInstances: $containsMultipleInstances
    ) {
      success
      message
      upload {
        id
        originalFilename
        fileSize
        fileType
        sourceType
        createdAt
        parent {
          id
        }
      }
      job {
        id
        status
        progress
        logs {
          id
          message
          createdAt
        }
      }
    }
  }
`;

export const APPROVE_DOCUMENT_TAGS = gql`
  mutation ApproveDocumentTags($ragUpload: ID!, $tags: [String!]!) {
    approveDocumentTags(ragUpload: $ragUpload, tags: $tags) {
      success
      message
      upload {
        id
        approvedTags
        tagsApproved
      }
    }
  }
`;

export const DELETE_RAG_DOCUMENT = gql`
  mutation DeleteRagDocument($ragUpload: ID!) {
    deleteRagDocument(ragUpload: $ragUpload) {
      success
      message
    }
  }
`;
